export const appcat = 'bidcab';